import React, { useEffect, useMemo, useState } from "react";
import ResourceStyle from "./resource.module.css";
import { Carousel, Select, Table, Input, Button } from "antd";
import{RedoOutlined} from '@ant-design/icons'
import styled from "styled-components";

import intrList from "../../assets/json/Resource/intr";
import { ColumsArrTop,resource_lotus_pic } from "../../assets/json/Resource/resource_lotus_pic";
import SearchComponent from "./component/Search";
const {Search}=Input
// 定义样式

const StyledTable = styled(Table)`
  /* 表头样式 */
  .ant-table-thead > tr > th {
    background-color: #e3f2d9 !important; /* 设置表头背景颜色 */
    color: #75bd42 !important; /* 设置表头文字颜色 */
    border: 1px solid #78bf46 !important; /* 设置表头边框颜色 */
    font-size: 18px !important;
  }

  /* 表格内容的单元格样式 */
  .ant-table-tbody > tr > td {
    border: 1px solid #c9e6b4 !important; /* 设置表格内容单元格的边框颜色 */
    background-color: #ffffff !important; /* 设置单元格背景色为白色 */
  }

  /* 鼠标悬停时保持背景色为白色 */
  .ant-table-tbody > tr:hover > td {
    background-color: #ffffff !important;
  }
`;

function Resource() {
  // const [searchQuery, setSearchQuery] = useState('');

  // const filteredData = useMemo(() => {
  //   if (!searchQuery) return resource_lotus_pic;

  //   const lowerCaseQuery = searchQuery.toLowerCase();
  //   return resource_lotus_pic.filter((item) => {
  //     return Object.values(item).some((value) =>
  //       String(value).toLowerCase().includes(lowerCaseQuery)
  //     );
  //   });
  // }, [searchQuery, resource_lotus_pic]);
  const [filteredData, setFilteredData] = useState(resource_lotus_pic);

  const handleSearch = (searchText) => {
    if (!searchText) {
      setFilteredData(resource_lotus_pic);
      return;
    }

    const lowerCaseQuery = searchText.toLowerCase();
    const filtered = resource_lotus_pic.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(lowerCaseQuery)
      )
    );
    setFilteredData(filtered);
  };
  return (
    <div className={ResourceStyle.Resource_app}>
      <div className={ResourceStyle.Resource_Header}>Germplasm information</div>
      <div className={ResourceStyle.Resource_search}>
        {/* <SearchComponent/> */}
        <Search
        style={{
          width:200
        }}
        placeholder="Input search text"
        onSearch={handleSearch}

        />
      
      </div>
      <StyledTable
        size="small"
        columns={ColumsArrTop}
        dataSource={filteredData}
        bordered
        style={{ width: '95%', margin: '10px auto' }}
        rowKey="id" // 假设每行数据有唯一的id字段
      />
      <div className={ResourceStyle.Resource_Header}>
        Introduction to long flowering period lotus germplasm resources
      </div>
      <div className={ResourceStyle.Resource_Lotus_variety}>
        <div className={ResourceStyle.Items_Grid}>
          {intrList.map((item) => {
            return (
              <div className={ResourceStyle.Item_Card}>
                <div className={ResourceStyle.Item_Image}>
                  <img
                    src={require(`../../assets/image/秋荷/${item.url}`)}
                    style={{ width: "100%", height: "100%" }}
                    loading="lazy"
                  />
                </div>
                <div className={ResourceStyle.Item_Info}>
                  <h3 style={{ fontSize: "20px" }}>
                    {item.name.split(".")[0]}
                  </h3>
                </div>
                <div className={ResourceStyle.Resource_mask}>
                  <p><span style={{fontWeight:"bold"}}>Plant type:</span> <span>{item.Plant_type}</span></p>
                  <p><span style={{fontWeight:"bold"}}>Flower color:</span> <span>{item.Flower_color}</span></p>
                  <p><span style={{fontWeight:"bold"}}>Flower Shape:</span> <span>{item.Flower_Shape}</span></p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ width: "100%", height: "30px" }}></div>
    </div>
  );
}

export default Resource;
